import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import ChatbotService from "../../services/chatbot.service";
import "./unanswered-questions.css";

const UnansweredQuestions = () => {
  const [attempt, setAttempt] = useState(0);
  const [loading, setLoading] = useState(true);
  const [failed, setFailed] = useState(false);
  const [total, setTotal] = useState(0);
  const Card = failed ? "div" : Link;

  useEffect(() => {
    let active = true;
    setLoading(true);
    setFailed(false);

    ChatbotService.listUnansweredQuestions(
      "unresolved", "", 0, 1, "created_at", "desc",
    ).then(({ data }) => {
      if (active) {
        setTotal(Number(data.total) || 0);
      }
    }).catch(() => {
      if (active) setFailed(true);
    }).finally(() => {
      if (active) setLoading(false);
    });

    return () => { active = false; };
  }, [attempt]);

  return (
    <section
      className="dashboard-unanswered-questions"
      aria-labelledby="dashboard-unanswered-title"
      aria-busy={loading}
    >
      <Card
        className="rbr-card uk-margin-small-right"
        {...(failed ? {} : { to: "/unanswered-questions?range=all", "aria-label": "Review questions" })}
      >
        <div className="rbr-card-head">
          <div className="rbr-card-title" id="dashboard-unanswered-title" role="heading" aria-level="3">
            <span className="rbr-ico guests" uk-icon="commenting" aria-hidden="true" />
            <span className="dashboard-unanswered-title-text" title="AI Chatbot Unanswered Questions">
              AI Chatbot Unanswered Questions
            </span>
          </div>
          <span className="rbr-tag">All time</span>
        </div>

      {loading ? (
        <div className="hms-blue-number">
          <span data-uk-spinner="ratio: 0.5;" aria-hidden="true" />
          <span role="status" className="uk-hidden-visually">Loading unanswered questions…</span>
        </div>
      ) : failed ? (
        <div role="alert">
          <p>Unable to load unanswered questions.</p>
          <button type="button" className="uk-button hms-btn hms-white-btn" onClick={() => setAttempt(value => value + 1)}>
            Try again
          </button>
        </div>
      ) : (
        <div className="hms-blue-number" aria-label={`${total.toLocaleString()} unresolved ${total === 1 ? "question" : "questions"}`}>
          {total.toLocaleString()}
        </div>
      )}
      </Card>
    </section>
  );
};

export default UnansweredQuestions;
